import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getRegistrosVerifactuPag (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    const data = await (new Promise((resolve, reject) => {
      const data = mock.getUsers
      const pages = data.data.length

      const clone = JSON.parse(JSON.stringify(data))
      if (params !== null) {
        clone.data = clone.data.slice(0, params.limit)
      }

      clone.meta.total = pages

      resolve(clone)
    }))
    data.respuesta = params && params.idGrupo ? data.data.filter(x => x.Grupos.some(g => g.IdGrupo === Number.parseInt(params.idGrupo))) : data.data
    return data
  } else {
    const req = {
      url: '/api/verifactu/getRegistrosVerifactuPag',
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: order,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getRegistrosVerifactuPag }
